import React, { useContext, useEffect, useState } from "react";
import { Layout, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { observer } from 'mobx-react-lite'
import { UserAvatar } from '../UserAvatar'
import { UnifiedUserAvatar } from "../UserAvatar/unified";
import { Notification } from "../Notification";
import { SearchBar } from "../SearchBar";
import { InviteEntry } from "./InviteEntry";
import { ContactEntry } from "./ContactEntry";
import { GuideEntry } from "./GuideEntry";
import { UpgradeEntry } from "./UpgradeEntry";
import './styles.less';
import { ROUTER_TEMPLATE_LIST } from "@/entry/route";
import { EasyDrawContext } from "@/store";
import { useIsMobile } from "@/hooks/useIsMobile";
import classNames from "classnames";
import { useTranslation } from 'react-i18next';
import Logo from "@/fabritor/UI/header/Logo";
import { getBrand } from "@/utils/brand";
const { Header } = Layout

export enum NAVBAR {
  DIAGRAM = 1,
  TEMPLATE = 2,
  LIBRARY = 3
}

type HeaderProps = {
  children?: JSX.Element
  onNavigateTo?: (id: NAVBAR) => void
  needSearch?: boolean
  className?: string
}

const prefixCls = 'easy-draw-header-wrapper'

export const IChengzi8Header = observer((props: HeaderProps) => {
  const { needSearch = true, className } = props
  const { t } = useTranslation('app', { keyPrefix: 'layout.header' });
  const location = useLocation();
  const store = useContext(EasyDrawContext)
  const templateStore = store.templateStore
  const userStore = store.userStore
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  

  const onSearch = (value: string) => {
    if (location.pathname !== ROUTER_TEMPLATE_LIST) {
      templateStore.resetSearch()
      templateStore.setSearchKeyword(value)
      navigate(ROUTER_TEMPLATE_LIST)
      props.onNavigateTo?.(NAVBAR.TEMPLATE)
    } else {
      templateStore.setSearchKeyword(value)
      templateStore.fetchTemplateList()
    }
  }
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (location.pathname !== ROUTER_TEMPLATE_LIST) {
      return
    }
    templateStore.setSearchKeyword(e.target.value)
    templateStore.fetchTemplateList()
  }

  

  return (
    <div className={classNames(prefixCls, className)}>
      
      <Header className={`${prefixCls}-layout-header`}>
        {/* <div className="logo" onClick={() => navigate('/')} >
          <span>{t('title')}</span> <span className="logo-subtitle">{t('subtitle')}</span>
        </div> */}
        <Logo onClick={() => navigate('/')} />
        <div className='navigate-wrapper'>
          {isMobile && needSearch ? (
            <SearchBar 
              placeholder={t('search_placeholder')} 
              size="middle" 
              allowClear 
              onSearch={onSearch}
              onChange={onChange}
              defaultValue={templateStore.searchFilter.keyword}
              style={{ width: '100%' }}
            />
          ) : needSearch && (
            <SearchBar 
              placeholder={t('search_placeholder_long')} 
              size="large" 
              allowClear
              onSearch={onSearch}
              onChange={onChange}
              defaultValue={templateStore.searchFilter.keyword}
              style={{ width: 450 }}
            />
          )}
        </div>

        {!isMobile && (
          <div className="right-actions">
            <GuideEntry />
            <ContactEntry />
            <InviteEntry />
            <Notification className="notification" />
            <UpgradeEntry />
            <UserAvatar className='avatar' />
          </div>
        )}
      </Header>
    </div>
  )
})


export const CanvopixHeader = observer((props: HeaderProps) => {
  const { needSearch = true, className } = props
  const { t } = useTranslation('app', { keyPrefix: 'layout.header' });
  const location = useLocation();
  const store = useContext(EasyDrawContext)
  const templateStore = store.templateStore
  const userStore = store.userStore
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  

  const onSearch = (value: string) => {
    if (location.pathname !== ROUTER_TEMPLATE_LIST) {
      templateStore.resetSearch()
      templateStore.setSearchKeyword(value)
      navigate(ROUTER_TEMPLATE_LIST)
      props.onNavigateTo?.(NAVBAR.TEMPLATE)
    } else {
      templateStore.setSearchKeyword(value)
      templateStore.fetchTemplateList()
    }
  }
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (location.pathname !== ROUTER_TEMPLATE_LIST) {
      return
    }
    templateStore.setSearchKeyword(e.target.value)
    templateStore.fetchTemplateList()
  }

  

  return (
    <div className={classNames(prefixCls, className)}>
      
      <Header className={`${prefixCls}-layout-header`}>
        {/* <div className="logo" onClick={() => navigate('/')} >
          <span>{t('title')}</span> <span className="logo-subtitle">{t('subtitle')}</span>
        </div> */}
        <Logo onClick={() => navigate('/')} />
        <div className='navigate-wrapper'>
          {isMobile && needSearch ? (
            <SearchBar 
              placeholder={t('search_placeholder')} 
              size="middle" 
              allowClear 
              onSearch={onSearch}
              onChange={onChange}
              defaultValue={templateStore.searchFilter.keyword}
              style={{ width: '100%' }}
            />
          ) : needSearch && (
            <SearchBar 
              placeholder={t('search_placeholder_long')} 
              size="large" 
              allowClear
              onSearch={onSearch}
              onChange={onChange}
              defaultValue={templateStore.searchFilter.keyword}
              style={{ width: 450 }}
            />
          )}
        </div>

        {!isMobile && (
          <div className="right-actions">
            <GuideEntry />
            <UnifiedUserAvatar className='avatar' />
          </div>
        )}
      </Header>
    </div>
  )
})


export default function UnifiedHeader(props: HeaderProps) {
  const brand = getBrand()
  if (brand.toLowerCase() === 'canvopix') {
    return <CanvopixHeader {...props} />
  }
  return <IChengzi8Header {...props} />
}
